import TagManager from 'react-gtm-module';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

const tagManagerArgs = {
  gtmId: process.env['REACT_APP_GTM'] || '',
};

TagManager.initialize(tagManagerArgs);

export { TagManager };
